import axios from 'axios'
import Cookies from 'js-cookie';
import { API_BASE_URL } from './config'
import router from '../router'
const http = axios.create({
  baseURL: `${API_BASE_URL}/api`, // 通用的请求地址前缀
  timeout: 600000, // 超时时间(毫秒)
  headers:{
      'Content-Type':'application/x-www-form-urlencoded'
  }
})
// 添加请求拦截器
http.interceptors.request.use(function (config) {
    const userStr = Cookies.get("userinfo");
    const headers = config.headers;
    if(userStr) {
        const userinfo = JSON.parse(userStr);
        headers.token = userinfo.token;
    }
    else {
        headers.token = '';
    }
    return config;
}, function (error) {
    console.log('request error', error)
  // 对请求错误做些什么
  return Promise.reject(error);
});

// 添加响应拦截器
http.interceptors.response.use((response) => {
  const { code, msg } = response.data;
  if(-2 == code) {
      router.push('/login');
      Cookies.remove('phoneKey');
      Cookies.remove('userinfo');
      alert(msg)
  }
  return response;
}, function (error) {
    const {code, msg} = error.response.data;
    if(-2 == code) {
        router.push('/login');
        Cookies.remove('phoneKey');
        Cookies.remove('userinfo');
        alert(msg)
    }
  // 对响应错误做点什么
  return Promise.reject(error);
});

export default http;